var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUppies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9452,
    cy: 23.9443,
    rx: 16.5,
    ry: 19,
    fill: "#94DDDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3494_1913)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3494_1913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2479 21.346C44.6165 9.86793 35.2003 1.60256 24.993 2.45432C24.8956 2.44884 24.7995 2.45283 24.7048 2.46629L18.104 3.40449C8.42527 4.78015 1.41311 13.4289 1.0393 23.5785C1.04334 23.6069 1.03926 23.6461 1.03382 23.6759C0.992289 25.0151 1.05897 26.3679 1.25414 27.7411C1.88948 32.2111 3.74943 36.1882 6.40676 39.3177C6.45406 39.3787 6.50137 39.4396 6.56761 39.4978C10.9605 44.5738 17.4667 47.3881 24.2191 46.4284L30.8199 45.4902C30.9147 45.4767 31.008 45.4538 31.1 45.4214C41.1404 43.3953 47.8725 32.8444 46.2398 21.3568L46.2479 21.346ZM13.9236 7.64112C12.2545 9.28896 10.8638 11.2644 9.82329 13.4605L6.96323 13.8671C8.69669 11.1763 11.0832 9.00134 13.9331 7.63977L13.9236 7.64112ZM5.52827 32.4572L9.17436 31.939C9.78061 33.5533 10.556 35.0662 11.4695 36.4629L8.17382 36.9314C7.1142 35.5941 6.22513 34.0973 5.52827 32.4572ZM8.31597 29.1625L4.58464 29.6928C4.37956 28.9297 4.20967 28.1423 4.09526 27.3373C3.98084 26.5323 3.93541 25.7368 3.90892 24.9387L7.64025 24.4083C7.67486 25.1957 7.74058 25.9979 7.85499 26.8029C7.96941 27.6079 8.12848 28.3872 8.31597 29.1625ZM7.69101 21.5026L4.04492 22.0209C4.25721 20.2516 4.70347 18.565 5.34717 16.9759C5.38505 16.9705 5.42427 16.9746 5.46216 16.9692L8.6442 16.517C8.15472 18.1034 7.83158 19.7725 7.70049 21.5013L7.69101 21.5026ZM10.603 39.4749L13.2925 39.0927C13.3494 39.0846 13.3954 39.0684 13.4508 39.0508C15.0729 40.8782 16.9589 42.3879 19.0211 43.5054C15.9047 42.9919 13.008 41.5775 10.5935 39.4763L10.603 39.4749ZM29.714 42.7392C20.6982 44.0207 12.1687 36.692 10.7056 26.3977C9.24242 16.1035 15.3826 6.6898 24.3984 5.40836C33.4142 4.12692 41.9436 11.4555 43.4068 21.7498C44.8699 32.0441 38.7203 41.4591 29.7045 42.7406L29.714 42.7392Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9864 27.4552C24.2947 29.6239 23.8315 30.3758 22.6572 30.5427C21.4828 30.7096 20.7529 29.8568 20.4797 27.9343L19.1417 18.5208L15.6566 19.0161L17.004 28.496C17.428 31.4791 18.4092 32.8082 20.1713 33.6496C21.0408 34.0574 22.0526 34.1744 23.1985 34.0116C25.263 33.7181 26.6573 32.5151 27.3322 30.7381C27.6778 29.8387 27.7233 28.5956 27.4945 26.9856L26.1511 17.5342L22.6566 18.0309L23.9972 27.4633L23.9864 27.4552Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5467 16.6472C35.7731 16.3707 34.6517 16.2982 33.1959 16.5244L28.5744 17.1813L30.7698 32.6275L34.1128 32.1523L33.425 27.3129L35.0539 27.0814C38.9652 26.5255 40.0169 23.7963 39.6103 20.9363C39.3142 18.8528 38.1331 17.2043 36.5467 16.6472ZM34.4287 23.6341L32.9323 23.8468L32.4101 20.1723L33.7738 19.9784C35.3269 19.7577 36.0882 20.2195 36.2673 21.4791C36.4544 22.7955 35.8303 23.4349 34.4287 23.6341Z",
    fill: "#194142"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3494_1913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.9382,
    height: 51.9382,
    fill: "white",
    transform: "translate(-4.55457 2.25439) rotate(-8.08942)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3494_1913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.4459,
    height: 43.4563,
    fill: "white",
    transform: "translate(-1.80273 6.23389) rotate(-8.08942)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUppies);
export default __webpack_public_path__ + "static/media/uppies.eaf3af35c4a41891a1ab8d98f113fa6c.svg";
export { ForwardRef as ReactComponent };